import { render, staticRenderFns } from "./ServiceTokens.vue?vue&type=template&id=33d6db22"
import script from "./ServiceTokens.vue?vue&type=script&lang=js"
export * from "./ServiceTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports